import MiniModal from './schema/BottomSheetViewState';
import { createStore } from 'satcheljs';

const preventComposeModalViewState: MiniModal = {
    isShown: false,
};

export const getModalViewState = createStore<MiniModal>(
    'preventComposeModalViewState',
    preventComposeModalViewState
);

export default getModalViewState;
